import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

export interface DetailItemAction {
  /** material icon name */
  icon: string;
  ariaLabel: string;
  onClick: () => void;
}

export interface DetailItem {
  label: string;
  value: string | number | null | undefined;
  action?: DetailItemAction;
}

@Component({
  selector: "app-details-card",
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: "./details-card.component.html",
  styleUrl: "./details-card.component.scss",
})
export class DetailsCardComponent {
  readonly title = input.required<string>();
  readonly items = input.required<DetailItem[]>();

  getDisplayValue(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    return String(value);
  }
}
